export type WorkspaceMembershipStatus = "ACTIVE" | "PENDING" | "SUSPENDED" | "LEFT";

export const WORKSPACE_MEMBERSHIP_STATUS = {
  ACTIVE: "ACTIVE",
  PENDING: "PENDING",
  SUSPENDED: "SUSPENDED",
  LEFT: "LEFT",
} as const;
